import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ResetPasswordForm from "./ResetPasswordForm";
import babyLogIcon from '../logo.svg';
import {
  Grid,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import firebaseAuthRef from "../firebase_auth"
import { verifyPasswordResetCode } from "firebase/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    maxWidth: 400,
    padding: theme.spacing(1),
    margin: 'auto',
  },
}));

interface ResetPasswordProps {
}

const ResetPassword: React.FC<ResetPasswordProps> = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const actionCode = queryParams.get('oobCode') ?? ""
  const classes = useStyles();
  const [error, setError] = useState<string | null>('');
  const [email, setEmail] = useState<string | null>('')
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyCode = async () => {
        verifyPasswordResetCode(firebaseAuthRef, actionCode).then((email) => {
    const accountEmail = email;
    setEmail(accountEmail)
    setError(null)
    setLoading(false)
  }).catch((error) => {
    setError("Your request to reset your password has expired or the link has already been used")
    setEmail(null)
    setLoading(false)
  });
    };
    verifyCode();
  }, [actionCode]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Box className={classes.form} sx={{ backgroundColor: 'white', padding: 2, borderRadius: 1 }}>
          <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
            <img src={babyLogIcon} alt="Baby Log Icon" width={40} />
          </Box>
          <Typography variant="h5">Reset Password</Typography>
          {loading && 
      <Box sx={{ display: 'flex',justifyContent: 'center',
    alignItems: 'center', }}>
      <CircularProgress />
    </Box>
   }
          {error && !loading && (
          <Alert severity="error" sx={{ marginBottom: 2 }}>
            {error}
          </Alert>
        )}
          {
            email && actionCode && !loading && (
              <ResetPasswordForm token={actionCode} email={email} />
              )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;